interface IField {
    start: number
    end: number
    html?: string
}

type TFormPartName = 'AREABOX' | 'BUTTON' | 'CHECKBOX' | 'DATEBOX' | 'INPUTBOX' | 'LISTBOX' | 'RADIO';

type TInputType = "email" | "number" | "password" | "tel" | "text" | "url";